export default "__VITE_ASSET__06ce89ab__"